import { mockApi } from '@/mock/api';
import { realApi } from './realApi';

const useMock = (import.meta.env?.VITE_USE_MOCK ?? 'true') !== 'false';

export const apiService = useMock ? mockApi : realApi;
export type ApiService = typeof mockApi;
